import Box from '@mui/material/Box';
import { t } from 'i18next';
import { useState } from 'react';

import Dialog from '~components/Dialog/Dialog';
import DialogActions from '~components/Dialog/DialogActions';
import DialogContent from '~components/Dialog/DialogContent';
import DialogHeader from '~components/Dialog/DialogHeader';
import { SmallButton } from '~components/Order/ordersDispatchStyledComponents';
import { LoadDigestLoadFilter } from '~hooks/useLoadDigests/models';

import LoadDigestLoadFilterRadioGroup from './LoadDigestLoadFilterRadioGroup';

interface LoadDigestViewDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onView: (loadFilter: LoadDigestLoadFilter) => void;
}

export default function LoadDigestViewDialog({
  isOpen,
  onClose,
  onView,
}: LoadDigestViewDialogProps) {
  const [loadFilter, setLoadFilter] = useState(LoadDigestLoadFilter.ALL);

  const handleClose = () => {
    setLoadFilter(LoadDigestLoadFilter.ALL);
    onClose();
  };

  const handleView = () => {
    onView(loadFilter);
    setLoadFilter(LoadDigestLoadFilter.ALL);
  };

  return (
    <Box onClick={(event) => event.stopPropagation()}>
      <Dialog isOpen={isOpen} maxWidth="sm" onClose={handleClose}>
        <DialogHeader onClose={handleClose}>
          {t('dispatch.load_digest.view_title')}
        </DialogHeader>

        <DialogContent>
          <LoadDigestLoadFilterRadioGroup onChange={setLoadFilter} value={loadFilter} />
        </DialogContent>

        <DialogActions>
          <SmallButton color="secondary" onClick={handleClose} variant="outlined">
            {t('actions.cancel')}
          </SmallButton>

          <SmallButton color="brandV2Yellow" onClick={handleView} variant="contained">
            {t('actions.view')}
          </SmallButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
